import React from "react";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import { useTranslation } from "react-i18next";

export const ErrorVaporPage = ({ children }) => {
  const { t } = useTranslation();

  return <ErrorBoundary t={t}> {children}</ErrorBoundary>;
};
